import React from 'react';
import surthrivalingMap from '../assets/surthrivaling_map.png';

function About() {
  return (
    <section id="about" className="section about">
      <div className="container">
        <header className="section__header reveal">
          <h2 className="section__title">About</h2>
        </header>

        <div className="about__layout reveal reveal--delay-1">
          <img
            src={surthrivalingMap}
            alt="World map with locations marked"
            className="about__map"
          />

          <div className="about__body">
            <p>
              By the time I was 5-years-old, I had already lived in 4 countries. So, the likelihood of me growing roots? Yeah, not so much. 
            </p>
            <p>
              Since then I&rsquo;ve spent an inordinate amount of time looking for answers to life&rsquo;s bigger questions. Sometimes in a woman&rsquo;s eyes. Sometimes in the depths of the ocean. Sometimes at the bottom of a pint glass. Results have been mixed.
            </p>
            <p>
              Surthrivaling is where I&rsquo;ve decided to document that search. Some observations. A few questionable decisions. The occasional useful lesson. We&rsquo;ll see where this goes.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
